import { ModelBase } from "Core/Models/ModelBase";
import { action, observable } from "mobx";
import { ReservationType1DTO, ReservationType1Model } from "./ReservationType1Model";
import { ReservationType1PurchaserDTO, ReservationType1PurchaserModel } from "./ReservationType1PurchaserModel";
import { ReservationType1FundingDTO, ReservationType1FundingModel } from "./ReservationType1FundingModel";
import { ReservationType1FundingContactDTO, ReservationType1FundingContactModel } from "./ReservationType1FundingContactModel";
import { ReservationType1SolicitorDTO, ReservationType1SolicitorModel } from "./ReservationType1SolicitorModel";
import { ReservationType1SolicitorContactDTO, ReservationType1SolicitorContactModel } from "./ReservationType1SolicitorContactModel";
import { ReservationType1FinancialDTO, ReservationType1FinancialModel } from "./ReservationType1FinancialModel";
import { ReservationType1FinancialAdditionalIncentivesDTO, ReservationType1FinancialAdditionalIncentivesModel } from "./ReservationType1FinancialAdditionalIncentivesModel";
import { ReservationType1SignaturesDTO, ReservationType1SignaturesModel } from "./ReservationType1SignaturesModel";
import { ReservationType1EarlyBirdDTO, ReservationType1EarlyBirdModel } from "./ReservationType1EarlyBirdModel";
import { ReservationSignatureStatusDTO, ReservationSignatureStatusModel } from "./ReservationSignatureStatusModel";
import { IndustryContactDTO, IndustryContactModel } from "../IndustryContactModel";
import { IndustryContactAdditionalContactDTO, IndustryContactAdditionalContactModel } from "../IndustryContactAdditionalContactModel";
import { ReservationType1FinancialIncentiveTypesDTO, ReservationType1FinancialIncentiveTypesModel } from "../ReservationType1FinancialIncentiveTypesModel";

export class ReservationAndRelatedModel extends ModelBase<ReservationAndRelatedModel, ReservationAndRelatedModelDTO> {
    //#region Properties
    @observable reservation = new ReservationType1Model();
    @observable purchaser = new ReservationType1PurchaserModel();
    @observable funding = new ReservationType1FundingModel();
    @observable fundingContacts: ReservationType1FundingContactModel[] = [];
    @observable solicitor = new ReservationType1SolicitorModel();
    @observable solicitorContacts: ReservationType1SolicitorContactModel[] = [];
    @observable financial = new ReservationType1FinancialModel();
    @observable financialAdditionalIncentives: ReservationType1FinancialAdditionalIncentivesModel[] = [];
    @observable signatures = new ReservationType1SignaturesModel();
    @observable signatureStatus = new ReservationSignatureStatusModel();
    @observable earlyBird = new ReservationType1EarlyBirdModel();
    @observable industryContacts: IndustryContactModel[] = [];
    @observable industryContactAdditionalContacts: IndustryContactAdditionalContactModel[] = [];
    @observable reservationType1FinancialIncentiveTypes: ReservationType1FinancialIncentiveTypesModel[] = [];
    //#endregion Properties

    @action
    public fromDto = (dto: ReservationAndRelatedModelDTO) => {
        dto.reservationType1 && this.reservation.fromDto(dto.reservationType1);
        dto.reservationType1Purchaser && this.purchaser.fromDto(dto.reservationType1Purchaser);
        dto.reservationType1Funding && this.funding.fromDto(dto.reservationType1Funding);

        this.fundingContacts = dto.reservationType1FundingContacts.map(fc => {
            const model = new ReservationType1FundingContactModel();
            model.fromDto(fc);
            return model;
        });

        dto.reservationType1Solicitor && this.solicitor.fromDto(dto.reservationType1Solicitor);

        this.solicitorContacts = dto.reservationType1SolicitorContacts.map(sc => {
            const model = new ReservationType1SolicitorContactModel();
            model.fromDto(sc);
            return model;
        });

        dto.reservationType1Financial && this.financial.fromDto(dto.reservationType1Financial);

        this.financialAdditionalIncentives = dto.reservationType1FinancialAdditionalIncentives.map(fi => {
            const model = new ReservationType1FinancialAdditionalIncentivesModel();
            model.fromDto(fi);
            return model;
        });

        dto.reservationType1Signatures && this.signatures.fromDto(dto.reservationType1Signatures);
        dto.reservationSignatureStatus && this.signatureStatus.fromDto(dto.reservationSignatureStatus);
        dto.reservationType1EarlyBird && this.earlyBird.fromDto(dto.reservationType1EarlyBird);

        this.industryContacts = dto.industryContacts.map(ic => {
            const model = new IndustryContactModel();
            model.fromDto(ic);
            return model;
        });

        this.industryContactAdditionalContacts = dto.industryContactAdditionalContacts.map(ica => {
            const model = new IndustryContactAdditionalContactModel();
            model.fromDto(ica);
            return model;
        });

        this.reservationType1FinancialIncentiveTypes = dto.reservationType1FinancialIncentiveTypes.map(fit => {
            const model = new ReservationType1FinancialIncentiveTypesModel();
            model.fromDto(fit);
            return model;
        });
    };

    public toDto = (): ReservationAndRelatedModelDTO => {
        throw "toDto is not supported";
    };
}

export interface ReservationAndRelatedModelDTO {
    reservationType1: ReservationType1DTO;
    reservationType1Purchaser: ReservationType1PurchaserDTO;
    reservationType1Funding: ReservationType1FundingDTO;
    reservationType1FundingContacts: ReservationType1FundingContactDTO[];
    reservationType1Solicitor: ReservationType1SolicitorDTO;
    reservationType1SolicitorContacts: ReservationType1SolicitorContactDTO[];
    reservationType1Financial: ReservationType1FinancialDTO;
    reservationType1FinancialAdditionalIncentives: ReservationType1FinancialAdditionalIncentivesDTO[];
    reservationType1Signatures: ReservationType1SignaturesDTO;
    reservationSignatureStatus: ReservationSignatureStatusDTO;
    reservationType1EarlyBird: ReservationType1EarlyBirdDTO;
    industryContacts: IndustryContactDTO[];
    industryContactAdditionalContacts: IndustryContactAdditionalContactDTO[];
    reservationType1FinancialIncentiveTypes: ReservationType1FinancialIncentiveTypesDTO[];
}
